import { render, staticRenderFns } from "./syAreaDataboard.vue?vue&type=template&id=a29fc014&scoped=true"
import script from "./syAreaDataboard.vue?vue&type=script&lang=js"
export * from "./syAreaDataboard.vue?vue&type=script&lang=js"
import style0 from "./syAreaDataboard.vue?vue&type=style&index=0&id=a29fc014&prod&lang=scss&scoped=true"
import style1 from "./syAreaDataboard.vue?vue&type=style&index=1&id=a29fc014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29fc014",
  null
  
)

export default component.exports